import React, { ReactElement } from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";

interface Props {
  onClick: () => void;
}

export function RequestAgencyMembership(props: Props): ReactElement {
  return (
    <div className="RequestAgencyMembership" onClick={props.onClick}>
      <h3>{translate(STRINGS.REQUEST_AGENCY_MEMBERSHIP)}</h3>
      <div className="__fake-input">{translate(STRINGS.TYPE_AGENCY_CODE)}</div>
    </div>
  );
}
